import type { ViewportState } from "../types/project";
import { clampFrame } from "./time";

export const MIN_VISIBLE_SECONDS = 0.1;

export function normalizeViewport(
  viewport: ViewportState,
  durationFrames: number,
  sampleRate: number,
): ViewportState {
  const min = Math.min(
    durationFrames,
    Math.max(1, Math.round(sampleRate * MIN_VISIBLE_SECONDS)),
  );
  return {
    centerFrame: clampFrame(viewport.centerFrame, durationFrames),
    visibleFrames: Math.min(
      durationFrames,
      Math.max(min, Math.round(viewport.visibleFrames)),
    ),
  };
}

export function dragViewport(
  viewport: ViewportState,
  deltaPixels: number,
  widthPixels: number,
  durationFrames: number,
  sampleRate: number,
): ViewportState {
  if (widthPixels <= 0) return viewport;
  return normalizeViewport(
    {
      ...viewport,
      centerFrame:
        viewport.centerFrame -
        (deltaPixels / widthPixels) * viewport.visibleFrames,
    },
    durationFrames,
    sampleRate,
  );
}

export function zoomViewport(
  viewport: ViewportState,
  scale: number,
  anchorFraction: number,
  durationFrames: number,
  sampleRate: number,
): ViewportState {
  if (!Number.isFinite(scale) || scale <= 0) return viewport;
  const anchor = Math.min(1, Math.max(0, anchorFraction));
  const oldLeft = viewport.centerFrame - viewport.visibleFrames / 2;
  const anchorFrame = oldLeft + anchor * viewport.visibleFrames;
  const nextVisible = viewport.visibleFrames / scale;
  const nextCenter = anchorFrame - (anchor - 0.5) * nextVisible;
  return normalizeViewport(
    { centerFrame: nextCenter, visibleFrames: nextVisible },
    durationFrames,
    sampleRate,
  );
}

export function overviewFractionToFrame(
  fraction: number,
  durationFrames: number,
): number {
  return clampFrame(
    Math.min(1, Math.max(0, fraction)) * durationFrames,
    durationFrames,
  );
}
